'<template>
   <div class="list_right" v-loading="loading">
      <div class="right_detail" v-if="artinfo != ''">
         <h5 class="detail_title">{{artinfo.title}}</h5>
         <div class="detail_source">
            <span v-if="artinfo.source != null">来源：{{artinfo.source}}</span>
            <span v-if="artinfo.author != null">作者：{{artinfo.author}}</span>
            <span> 时间：{{artinfo.createTime.substring(0,10)}}</span>
         </div>
         <div class="detail_desc" v-html="artinfo.content"></div>
         <div class="detail_fileList" v-if="artinfo.documentFile != null">
            <h4>附件下载：</h4>
            <ul>
               <li>
                  <a :href="artinfo.documentFile" :title="artinfo.title" target="_blank">相关资料</a>
               </li>
            </ul>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'user_info_page',
      components: {},
      data() {
         return {
            loading: true,
            data: null,
            code: '',

            artinfo: '',

            list: [],
            pageNum: 1,
            pageSize: 5,
            pagecount: 10,
         };
      },
      watch: {
         $route() {

         },
         '$route.query.code': {
            handler(newVal, oldVal) {
               //判断newVal有没有值监听路由变化
               if (this.$route.params.code) {
                  this.code = this.$route.params.code;
               } else {
                  this.code = '';
               }
            },
            deep: true
         }
      },
      mounted() {
         this.code = this.$route.params.code;
         this.data = JSON.parse(localStorage.getItem('userInfo'));
         this.getInfo();
      },
      methods: {
         getInfo() {
            var _this = this;
            _this.loading = true;
            _this.$api.activityInfo({
               code: this.code,
               token: this.$getCookie('sd_token')
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.artinfo = res.data;
                  _this.artinfo.artFileList = [];
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less" scoped>

</style>
